export async function getImgSize(url: string): Promise<{
  width: number
  height: number
  url: string
}> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = url
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height,
        url
      })
    }
    img.onerror = () => {
      resolve({
        width: 1000,
        height: 1000,
        url: 'https://resource.mfuns.net/imgs/placeholder/img-404.png'
      })
    }
  })
}
